module.exports = __webpack_public_path__ + "assets/img/index-company4.0b126aa1.jpg";